<div class="vdo-container">
  <div class="vdo-wrapper">
    <img src="../../../assets/images/Video.jpg" class="img-align">
  </div>
</div>
<div class="vdo-list-wrapper">
  @for (v of videoList; track v) {
    <div class="vdo-list">
      <img src="{{v.imgSource}}">
      <div class="title">{{ v.title }}</div>
    </div>
  }
</div>